import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpgradeGradient = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_15819_12180)",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 29,
				height: 29,
				rx: 5,
				fill: "url(#paint0_linear_15819_12180)"
			}), /* @__PURE__ */ _jsx("g", {
				clipPath: "url(#clip1_15819_12180)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M11.3688 13.3555L13.1533 10.2818C13.4094 9.83784 13.6732 9.39557 13.926 8.94818C14.0029 8.81214 14.1146 8.69897 14.2496 8.62023C14.3846 8.54149 14.5381 8.5 14.6944 8.5C14.8507 8.5 15.0042 8.54149 15.1392 8.62023C15.2742 8.69897 15.3859 8.81214 15.4628 8.94818C16.2671 10.3399 17.0745 11.7299 17.885 13.1181C17.926 13.189 17.9704 13.259 18.0259 13.3512L19.8249 12.5171C20.2518 12.3198 20.6735 12.1252 21.0953 11.9194C21.2397 11.8342 21.4052 11.7917 21.5728 11.7967C21.7404 11.8017 21.9031 11.854 22.0422 11.9476C22.1774 12.039 22.2805 12.1706 22.337 12.3238C22.3936 12.477 22.4006 12.644 22.3572 12.8014C22.0424 14.5545 21.7268 16.3073 21.4104 18.0599C21.3344 18.48 21.2618 18.9009 21.1824 19.3201C21.1548 19.5184 21.0554 19.6996 20.9031 19.8295C20.7507 19.9593 20.556 20.0287 20.3559 20.0245C20.2791 20.0296 20.2014 20.0245 20.1245 20.0245H9.26081C8.54192 20.0245 8.2909 19.8273 8.16795 19.1485C7.78716 17.0442 7.40836 14.9376 7.03155 12.8287C6.98616 12.6723 6.98982 12.5058 7.04204 12.3516C7.09425 12.1974 7.19251 12.063 7.32355 11.9664C7.46289 11.866 7.62833 11.8082 7.79985 11.7998C7.97137 11.7915 8.14163 11.833 8.29005 11.9194C9.30521 12.395 10.3221 12.8663 11.3637 13.3529",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_15819_12180",
				x1: 25.9694,
				y1: -28.5167,
				x2: -5.43993,
				y2: -24.0506,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#2214E4" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .52,
						stopColor: "#D696CE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#2F67FE"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_15819_12180",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 29,
					height: 29,
					rx: 5,
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_15819_12180",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 29,
					height: 29,
					fill: "white"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgUpgradeGradient);
export default ForwardRef;
